export default __webpack_public_path__ + "static/media/ISSO CLASS-3 EXAM PATTERN 2025.1d0122dd.pdf";